
import { GameManager } from "../GameManager"; 

export class BootScene extends Phaser.Scene {

    public static bootedInWrongOrientation: boolean;

    constructor() {

        super("BootScene");
    }

    public preload(): void {

        this.load.atlas("texture_atlas_0", "assets/texture_atlas_0.png", "assets/texture_atlas_0.json");
    }

    public create(): void {

        GameManager.setCurrentScene(this);

        this.scene.setVisible(false);

        if (!this.game.device.os.desktop) {

            const w = window.innerWidth;
            const h = window.innerHeight;

            if (w < h) {
                BootScene.bootedInWrongOrientation = false;
                GameManager.init();
            } else {
                BootScene.bootedInWrongOrientation = true;

                document.getElementById("orientation").style.display = "block";
                document.getElementById("content").style.display = "none"; 
            }  

        } else {
            GameManager.init();
        }
    }
}
